//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================
 
// custom pages
import config from "config/index";
import HandleApiResponse from "helpers/handleApiResponse";
 
const response = () => {
  const { handleResponse, handleError } = HandleApiResponse();
  async function getsignature(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"
        },
      };
      let query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/thrive-signature/get-signature?query=${query}`,
        obj
      );
      return handleResponse(res);
    }
    catch (err) {
      handleError(err);
    }
  }
 
  async function searchAPI(values) {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"
        },
      };
      let query;
      query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/thrive-signature/search?query=${query}`,
        obj
      );
 
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }
 
  async function filter(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"
        },
      };
      let query;
      query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/thrive-signature/filter?query=${query}`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }
 
  async function getPending(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"
        },
      };
      let query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/thrive-signature/get-pending?query=${query}`,
        obj
      );
      return handleResponse(res);
    }
    catch (err) {
      handleError(err);
    }
  }
  async function salesRepRejectAPI(values) {
    try {
      const obj = {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(values), // Send `values` in the body
      };
  
      const res = await fetch(
        `${config.host}/cdr-panel/thrive-signature/reject-enrollment`,
        obj
      );
  
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  
  async function searchPending(values) {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"
        },
      };
      let query;
      query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/thrive-signature/searchPending?query=${query}`,
        obj
      );
 
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }
 
  async function getLogs(values) {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"
        },
      };
      let query;
      query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/thrive-signature/signature-enrollment-logs?query=${query}`,
        obj
      );
 
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }
 
  async function salesRepMappingApi(values) {
    try {
      const obj = {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(values), // Send `values` in the body
      };
 
      const res = await fetch(
        `${config.host}/cdr-panel/thrive-signature/sales-rep-mapping`,
        obj
      );
 
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }
 
  async function billingConfirmationApi(values) {
    try {
      const obj = {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(values), // Send `values` in the body
      };
 
      const res = await fetch(
        `${config.host}/cdr-panel/thrive-signature/billing-confirmation`,
        obj
      );
 
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }
 
  async function addOnPlansMappingApi(values) {
    try {
      const obj = {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(values), // Send `values` in the body
      };
 
      const res = await fetch(
        `${config.host}/cdr-panel/thrive-signature/add-on-plans-mapping`,
        obj
      );
 
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }
 
  async function enrollmentExport(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/thrive-signature/enrollment-export?query=${query}`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }
 
  async function billingClosureApi(values) {
    try {
      const obj = {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(values), // Send `values` in the body
      };
 
      const res = await fetch(
        `${config.host}/cdr-panel/thrive-signature/billing-closure-uenrollment`,
        obj
      );
 
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }
 
  async function addOnPlansRemover(values) {
    try {
      const obj = {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(values), // Send `values` in the body
      };
 
      const res = await fetch(
        `${config.host}/cdr-panel/thrive-signature/add-on-plans-remover-unenrollment`,
        obj
      );
 
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function createUnenrollmentReqAPI(values) {
    try {
      const obj = {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(values),
      };
  
      const res = await fetch(
        `${config.host}/cdr-panel/thrive-signature/create-unenrollment`,
        obj
      );
  
      // Optional: Safety check before handling
      if (!res.ok) throw new Error(`Request failed with status ${res.status}`);
  
      return handleResponse(res);
    } catch (err) {
      return handleError(err); // Ensure error is passed along
    }
  }
  
  async function getPendingUnenrollment(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"
        },
      };
      let query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/thrive-signature/get-pending-unenrollment?query=${query}`,
        obj
      );
      return handleResponse(res);
    }
    catch (err) {
      handleError(err);
    }
  }
  async function getsignatureUnenrollment(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"
        },
      };
      let query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/thrive-signature/get-signature-unenrollment?query=${query}`,
        obj
      );
      return handleResponse(res);
    }
    catch (err) {
      handleError(err);
    }
  }

  async function searchPendingUnenrollment(values) {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"
        },
      };
      let query;
      query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/thrive-signature/searchPending-unenrollment?query=${query}`,
        obj
      );
 
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function unenrollmentsearchAPI(values) {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"
        },
      };
      let query;
      query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/thrive-signature/unenrollment-search?query=${query}`,
        obj
      );
 
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }
  async function unenrollmentFilter(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"
        },
      };
      let query;
      query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/thrive-signature/unenrollment-filter?query=${query}`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }
  async function getsignatureUnenrollmentReason(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"
        },
      };
      
      let res = await fetch(
        `${config.host}/cdr-panel/thrive-signature/unenrollment-reason`,
        obj
      );
      return handleResponse(res);
    }
    catch (err) {
      handleError(err);
    }
  }

  async function unenrollmentExport(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/thrive-signature/unenrollment-export?query=${query}`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }
  async function upload(values) {
    try {
        const obj = {
            method: "POST",
            credentials: "include",
            body: values,
        };

        const res = await fetch(
            `${config.host}/cdr-panel/thrive-signature/upload`, // ← use backticks here
            obj
        );

        return handleResponse(res);
    } catch (err) {
        handleError(err);
    }
  }

    async function getShiptoDetailsByShipto(values) {
      try {
        const obj = {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json"
          },
        };
        let query;
        query = JSON.stringify(values);
        let res = await fetch(
          `${config.host}/cdr-panel/thrive-signature/get-details-by-shipto?query=${query}`,
          obj
        );

        return handleResponse(res);
      } catch (err) {
        handleError(err);
      }
    }

    async function updateEmail(values) {
      try {
          const obj = {
            method: "POST",
            credentials: "include",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify(values)
          };

          const res = await fetch(
              `${config.host}/cdr-panel/thrive-signature/update-email`, // ← use backticks here
              obj
          );

          return handleResponse(res);
      } catch (err) {
          handleError(err);
      }
    }

    async function getbillingrecord(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"
        },
      };
      let query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/thrive-signature/billing-record-enrollment?query=${query}`,
        obj
      );
      return handleResponse(res);
    }
    catch (err) {
      handleError(err);
    }
  }

  async function billingdateenrollment(values) {
    try {
      const obj = {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(values),
      };
  
      const res = await fetch(
        `${config.host}/cdr-panel/thrive-signature/billing-datesetting-enrollment`,
        obj
      );
  
      // Optional: Safety check before handling
      if (!res.ok) throw new Error(`Request failed with status ${res.status}`);
  
      return handleResponse(res);
    } catch (err) {
      return handleError(err); // Ensure error is passed along
    }
  }

   async function billingenrollmentsearchAPI(values) {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"
        },
      };
      let query;
      query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/thrive-signature/billing-record-enrollment-search?query=${query}`,
        obj
      );
 
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }


  async function getbillingunenrollmentrecord(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"
        },
      };
      let query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/thrive-signature/billing-record-unenrollment?query=${query}`,
        obj
      );
      return handleResponse(res);
    }
    catch (err) {
      handleError(err);
    }
  }

  async function billingdateunenrollment(values) {
    try {
      const obj = {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(values),
      };
  
      const res = await fetch(
        `${config.host}/cdr-panel/thrive-signature/billing-datesetting-unenrollment`,
        obj
      );
  
      // Optional: Safety check before handling
      if (!res.ok) throw new Error(`Request failed with status ${res.status}`);
  
      return handleResponse(res);
    } catch (err) {
      return handleError(err); // Ensure error is passed along
    }
  }

   async function billingunenrollmentsearchAPI(values) {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"
        },
      };
      let query;
      query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/thrive-signature/billing-record-unenrollment-search?query=${query}`,
        obj
      );
 
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }


   async function getaddplanrecord(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"
        },
      };
      let query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/thrive-signature/addplan-record-enrollment?query=${query}`,
        obj
      );
      return handleResponse(res);
    }
    catch (err) {
      handleError(err);
    }
  }

   async function addplanenrollmentsearchAPI(values) {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"
        },
      };
      let query;
      query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/thrive-signature/addplan-record-enrollment-search?query=${query}`,
        obj
      );
 
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }


   async function getaddplanunenrollrecord(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"
        },
      };
      let query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/thrive-signature/addplan-record-unenrollment?query=${query}`,
        obj
      );
      return handleResponse(res);
    }
    catch (err) {
      handleError(err);
    }
  }

   async function addplanenrollmentunenrollsearchAPI(values) {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"
        },
      };
      let query;
      query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/thrive-signature/addplan-record-unenrollment-search?query=${query}`,
        obj
      );
 
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function cancelenrollmentAPI(values) {
    try {
      const obj = {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(values), // Send `values` in the body
      };
  
      const res = await fetch(
        `${config.host}/cdr-panel/thrive-signature/cancel-enrollment`,
        obj
      );
  
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }


 
 
 
  return {
    getsignature,
    searchAPI,
    filter,
    getPending,
    searchPending,
    getLogs,
    salesRepMappingApi,
    billingConfirmationApi,
    addOnPlansMappingApi,
    enrollmentExport,
    billingClosureApi,
    addOnPlansRemover,
    salesRepRejectAPI,
    createUnenrollmentReqAPI,
    getPendingUnenrollment,
    getsignatureUnenrollment,
    searchPendingUnenrollment,
    unenrollmentsearchAPI,
    unenrollmentFilter,
    getsignatureUnenrollmentReason,
    unenrollmentExport,
    upload,
    getShiptoDetailsByShipto,
    updateEmail,
    getbillingrecord,
    billingdateenrollment,
    billingenrollmentsearchAPI,
    getbillingunenrollmentrecord,
    billingdateunenrollment,
    billingunenrollmentsearchAPI,
    getaddplanrecord,
    addplanenrollmentsearchAPI,
    getaddplanunenrollrecord,
    addplanenrollmentunenrollsearchAPI,
    cancelenrollmentAPI

  };
};
 
export default response;
 
 